import React, { useState } from "react";
import Sidebar from "./Sidebar";
import ContentArea from "./ContentArea";
import Toolbar from "./Toolbar";
import useFileManager from "../../hooks/useFileManager";
import "./FileManager.css";
import FileManagerModal from "./FileManagerModal";

function FileManager() {
  const {
    folders,
    files,
    currentPath,
    createFile,
    renameFile,
    deleteFile,
    downloadFile,
    uploadFile,
    uploadLinkFile,
    copyFile,
    moveFile,
    previewFile,
    goBack,
    goHome,
    goToFolder,
    clearSelectedRows,
    setClearSelectedRows,
    loading,
  } = useFileManager();

  const [isModalVisible, setModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalAction, setModalAction] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [sourcePath, setSourcePath] = useState("");
  const showModalWithContent = (title, action) => {
    setModalTitle(title);
    setModalAction(action);
    setModalVisible(true);
  };

  const hideModal = () => {
    setModalVisible(false);
    setModalAction(null);
    setClearSelectedRows(true);
  };

  const handleFileAction = (action) => {
    if (action === "create") {
      showModalWithContent("Create Folder", "create");
    } else if (action === "rename" && selectedFiles.length === 1) {
      showModalWithContent("Rename Item", "rename");
    } else if (action === "delete" && selectedFiles.length > 0) {
      const yes = window.confirm(
        "Are you sure you want to delete selected files?"
      );
      if (!yes) return;
      const fileNamesToDelete = selectedFiles.map((file) => file.name);
      const fileIdsToDelete = selectedFiles.map((file) => file.id || 0);
      deleteFile(fileNamesToDelete, fileIdsToDelete);
      setSelectedFiles([]);
    } else if (action === "download" && selectedFiles.length > 0) {
      const fileNamesToDownload = selectedFiles.map((file) => file.name);
      downloadFile(fileNamesToDownload);
      setSelectedFiles([]);
    } else if (action === "upload") {
      showModalWithContent("Upload Files", "upload");
    } else if (action === "uploadLink") {
      showModalWithContent("Upload Link", "uploadLink");
    } else if (action === "move" && selectedFiles.length > 0) {
      setSourcePath(currentPath);
      showModalWithContent("Move to Folder", "move");
    } else if (action === "copy" && selectedFiles.length > 0) {
      setSourcePath(currentPath);
      showModalWithContent("Copy to Folder", "copy");
    } else if (action === "preview" && selectedFiles.length === 1) {
      previewFile(selectedFiles[0]);
    }
  };

  const saveData = async (data) => {
    console.log(data.link);
    const itemNames = selectedFiles.map((file) => file.name);

    if (modalAction === "create") {
      createFile(data.folderName);
    } else if (modalAction === "rename" && selectedFiles.length === 1) {
      renameFile(
        selectedFiles[0].name,
        data.newName,
        selectedFiles[0].type === "Folder"
      );
    } else if (modalAction === "upload" && data.files) {
      await uploadFile(data.files);
    } else if (modalAction === "copy") {
      await copyFile(sourcePath, data.destinationPath, itemNames);
    } else if (modalAction === "move") {
      await moveFile(sourcePath, data.destinationPath, itemNames);
    } else if (modalAction === "uploadLink") {
      await uploadLinkFile(data.link);
    }
    hideModal();
  };

  const handleGoBack = async () => {
    await goBack();
    setClearSelectedRows(true);
  };

  const handleGoHome = async () => {
    await goHome();
    setClearSelectedRows(true);
  };

  return (
    <div className="file-manager">
      <Sidebar
        folders={folders}
        onSelectFolder={(folderName) => goToFolder(folderName, "Sidebar")}
        loading={loading}
        currentPath={currentPath}
      />
      <div className="main-content">
        <Toolbar
          onAction={handleFileAction}
          goBack={handleGoBack}
          goHome={handleGoHome}
          currentPath={currentPath}
        />
        <ContentArea
          files={files}
          onSelectFile={setSelectedFiles}
          goToFolder={(folderName) => goToFolder(folderName, "ContentArea")}
          clearSelectedRows={clearSelectedRows}
          previewFile={previewFile}
          loading={loading}
        />
      </div>

      {isModalVisible && (
        <FileManagerModal
          title={modalTitle}
          action={modalAction}
          defaultValue={selectedFiles[0]?.name}
          folders={files}
          goToFolder={goToFolder}
          goBack={handleGoBack}
          currentPath={currentPath}
          onSubmit={saveData}
          onClose={hideModal}
          loading={loading}
        />
      )}
    </div>
  );
}

export default FileManager;
